import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import CtaLink from 'components/essentials/Cta/CtaLink';
import useIsTouchDevice from 'hooks/useIsTouchDevice';
import notificationBannerHelper from './utils';
import NotificationBannerSkeleton from './NotificationBannerSkeleton';
const FabricFavoritedBanner = t0 => {
  const $ = _c(10);
  const {
    fabricName,
    isUserLoggedIn,
    onClose
  } = t0;
  const isTouchDevice = useIsTouchDevice();
  const t1 = `${fabricName} has been added to your favorites.`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mt-4">Keep track of your favorite fabrics all in one place. Simply double click the swatch to add or remove from your favorites list.</div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== isUserLoggedIn) {
    t3 = !isUserLoggedIn && <div className="mt-4"><CtaLink to={`/sign-in/?redirect=${window.location.pathname}`} styling="link-style" color="brand" onClick={_temp} textClassName="!inline underline">Sign in</CtaLink> to your account to make sure your favorites are saved.</div>;
    $[1] = isUserLoggedIn;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <div className="text-sm flex flex-col items-start">{t2}{t3}</div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = !isTouchDevice;
  let t6;
  if ($[5] !== onClose || $[6] !== t1 || $[7] !== t4 || $[8] !== t5) {
    t6 = <NotificationBannerSkeleton modifier="top" title={t1} body={t4} onClose={onClose} keepOpenOnMouseEnter={t5} />;
    $[5] = onClose;
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
FabricFavoritedBanner.propTypes = {
  onClose: PropTypes.func,
  fabricName: PropTypes.string,
  isUserLoggedIn: PropTypes.bool
};
export default FabricFavoritedBanner;
function _temp() {
  return notificationBannerHelper.hideMsg();
}